module.exports = fox._r("images/christmass/gift-173.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/christmass/gift-173.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/christmass/gift-173.png
// module id = 397
// module chunks = 4